<template>

    <div class="user-center-container">
        <van-pull-refresh
            v-model="isLoading"
            success-text="刷新成功"
            @refresh="onRefresh"
            >
            <template #pulling>
                <div class="refresh-loading">
                    <span class="refresh-loading-info">继续下拉刷新</span>
                </div>
            </template>
            <template #loosing>
                <div class="refresh-loading">
                    <span class="refresh-loading-info">释放即可刷新</span>
                </div>
            </template>
            <template #loading>
                <div class="refresh-loading">
                    <van-loading color="#fff" size="24">
                        <span class="refresh-loading-info" >加载中...</span>
                    </van-loading>
                </div>
            </template>
            <template #success>
                <div class="refresh-loading">
                    <span class="refresh-loading-info">刷新成功</span>
                </div>
            </template>
            <template #normal>
                <div class="refresh-loading">
                </div>
            </template>
            <!-- 用户信息 -->
            <div class="title-background-container"></div>
            <div class="info-container">
                <div class="info-wrap">
                    <van-col span="23" offset="1">
                        <van-row class="flex-center">
                            <van-col span="17" class="flex-center">
                                <div style="display:inline;" @click="$router.push({ name : 'UserInfo' })">
                                    <van-image round fit="cover" width="1.2rem" height="1.2rem" :src="$store.state.userInfo.avatar"/>
                                </div>
                                <div style="display: inline;">
                                    <div class="info-content">
										<div>
											<div class="info-name" @click="$router.push({ name : 'UserInfo' })">{{$store.state.userInfo.nickname}}</div>
											<van-tag plain class="info-tag" size="medium" round>{{$store.state.userInfo.level_name}}</van-tag>
										</div>
										<div class="info-id" @click="$router.push({ name : 'UserInfo' })">ID: {{userSimpleId}}</div>
                                    </div>
                                </div>
                            </van-col>
                            <van-col span="3" class="flex-center" style="justify-content: center;">
                                <div  class="flex-center">
                                    <svg style="width: 0.7rem; height: 0.7rem;" @click="show_theme = true">
                                        <use xlink:href="#icon-theme"></use>
                                    </svg>
                                </div>
                            </van-col>
                            <van-col span="3" offset="1" class="flex-center" style="justify-content: center;">
                                <div  class="flex-center">
                                    <van-image width="0.7rem" height="0.7rem" :src="require('../../assets/images/er_card.png')" @click="$router.push({ name : 'PaymentCode' })" />
                                </div>
                            </van-col>
                        </van-row>
                    </van-col>
                </div>
                <van-row style="text-align: center;  padding: 10px 0; color: #000;">
                    <van-col span="22" offset="1" style="border-radius: 0.2rem;background-color: rgba(255,255,255, 1);padding: 0.3rem;">
                        <van-col :span="8">
                            <div class="info-value-title">余额</div>
                            <div class="info-value">{{$store.state.userInfo.card_balance}}元</div>
                        </van-col>
                        <van-col :span="8">
                            <div class="info-value-title">积分</div>
                            <div class="info-value">{{$store.state.userInfo.card_integral + $store.state.userInfo.integral}}</div>
                        </van-col>
                        <van-col :span="8" @click="$router.push({name : 'LotteryChance'})">
                            <div class="info-value-title">抽奖次数</div>
                            <div class="info-value">{{$store.state.userInfo.lottery_frequency}}</div>
                        </van-col>
                    </van-col>
                </van-row>
            </div>
            <van-cell-group title="我的订单">
                <van-cell v-for="(basicItem, basicIndex) in basicOption" :key="basicIndex" is-link :to="{ name : basicItem.link }">
                    <template #title>
                        <svg class="icon" aria-hidden="true">
                            <use :xlink:href="basicItem.icon"></use>
                        </svg>
                        <span style="margin-left: 10px;">{{basicItem.text}}</span>
                    </template>
                </van-cell>
            </van-cell-group>
            <van-cell-group title="其他" style="margin-bottom: 24px;">
                <van-cell v-for="(basicItem, basicIndex) in commpnOptionIsStaff" :key="basicIndex" is-link :to="{ name : basicItem.link }" @click="basicItem.event">
                    <template #title>
                        <svg class="icon" aria-hidden="true">
                            <use :xlink:href="basicItem.icon"></use>
                        </svg>
                        <span style="margin-left: 10px;">{{basicItem.text}}</span>
                    </template>
                </van-cell>
            </van-cell-group>

            <van-popup v-model="show_theme" round position="bottom" @closed="themeChange">
                <div class="theme-title">
                    <span>选择主题</span>
                </div>
                <van-radio-group v-model="themeRadio" style="padding-bottom: 0.3rem;">
                    <van-cell-group>
                        <van-cell title="黄色" clickable @click="themeRadio = 'yellow'">
                            <template #right-icon>
                                <van-radio name="yellow" />
                            </template>
                        </van-cell>
                        <van-cell title="红色" clickable @click="themeRadio = 'red'">
                            <template #right-icon>
                                <van-radio name="red" />
                            </template>
                        </van-cell>
                        <van-cell title="蓝色" clickable @click="themeRadio = 'blue'">
                            <template #right-icon>
                                <van-radio name="blue" />
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </van-popup>
        </van-pull-refresh>
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk'
    import api from '../../assets/js/api'
    import auth from '../../assets/js/auth'
    import '../../assets/icon/iconfont'
    import { Dialog } from 'vant'

    export default {
        name: 'Index',
        data () {
            return {
                basicOption: [
                    {
                        text: '消费订单',
                        icon: '#icon-chezhudaikuan',
                        link: 'ConsumeOrder'
                    },
                    {
                        text: '充值订单',
                        icon: '#icon-zixun',
                        link: 'RechargeOrder'
                    },
                    {
                        text: '积分兑换订单',
                        icon: '#icon-jifendingdan',
                        link: 'IntegralOrder'
                    },
                ],
                isLoading: false,
                isDisabled: false,
                themeRadio: 'blue',
                show_theme: false,
				isInviteAble: false
            }
        },
        created() {
			let self = this;
            if(!this.$route.query.token){
                this.$store.commit('refreshUserInfo');  //刷新用户信息
            };
            if(document.querySelector('body').getAttribute('data-theme')) {
                this.themeRadio = document.querySelector('body').getAttribute('data-theme');
            }
			api.request('/user/get_activity_invite').then(res => {
				self.isInviteAble = res.data.is_consume_invite || res.data.is_recharge_invite ? true : false;
			});
        },
        methods: {
            onRefresh() {
				this.$store.commit('refreshUserInfo');
                setTimeout(() => {
                    this.isLoading = false;
                }, 1000);
            },
            scanCoupons() {
                let self = this;
                if(self.isLoading) {
                    self.$notify('系统正在核销，请稍后')
                    return
                }
                wx.scanQRCode({
                    needResult: 1,
                    scanType: ["qrCode"],
                    success: function (res) {
                        if(res.resultStr) {
                            api.request('/exchange/write_off', {
                                code: res.resultStr
                            }).finally(() => {
                                self.isLoading = false;
                                self.isDisabled = false;
                            }).then((res) => {
                                Dialog.alert({
                                    message: res.msg,
                                });
                            }).catch((err) => {
                                console.log(err)
                                Dialog.alert({
                                    message: err.msg,
                                });
                            })
                        }
                    }
                });
            },
            themeChange() {
                if (this.themeRadio !== '' ) {
                    document.querySelector('body').setAttribute('data-theme', this.themeRadio)
                    localStorage.setItem('themeColor', this.themeRadio)
                }
            }
        },
        computed: {
			userSimpleId() {
				return this.$store.state.userInfo.id && this.$store.state.userInfo.id.slice(-5).toUpperCase()
			},
            commpnOptionIsStaff() {
                return this.commonOption.filter(option => !(option.permission && !option.permission.allow))
            },
            commonOption() {
                return [{
                    text: '我的油卡',
                    icon: '#icon-youka',
                    link: 'Card'
                },
                {
                    text: '优惠券',
                    icon: '#icon-youhuiquan',
                    link: 'CouponIndex'
                },
                {
                    text: '兑换券',
                    icon: '#icon-kaquan',
                    link: 'ExchangeIndex'
                },
                {
                    text: '电子发票',
                    icon: '#icon-dianzihuidan',
                    link: 'InvoiceOrderList',
					permission: {
                        allow: this.$store.state.systemConfig['invoice.is_enable']
                    }
                },
                {
                    text: '邀请有礼',
                    icon: '#icon-yaoqing',
                    link: 'InviteCode'
                },
                {
                    text: '车主认证',
                    icon: '#icon-renzheng',
                    link: 'Certification',
                    permission: {
                        allow: this.$store.state.systemConfig['car_auth.is_enable']
                    }
                },
                {
                    text: '公司认证',
                    icon: '#icon-gongsi',
                    link: 'CompanyList',
                    permission: {
                        allow: this.$store.state.systemConfig['company_auth.is_enable']
                    }
                },
                // {
                //     text: '意见反馈',
                //     icon: '#icon-kefu',
                //     link: 'NotOpen'
                // },
                {
                    text: '核销兑换券',
                    icon: '#icon-saoma',
                    event: this.scanCoupons,
                    permission: {
                        allow: this.$store.state.userInfo.is_staff
                    }
                },
                {
                    text: '邀请消费',
                    icon: '#icon-yaoqing',
                    link: 'InviteConsume',
                    permission: {
                        allow: this.isInviteAble
                    }
                },
            ]}
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../style/themeify.scss';
    *{
        @include themeify{
            .flex-center {
                display: flex;
                align-items: center;
                height: 100%;
            }
            .refresh-loading {
                width: 100%;
                height: 100%;
                background: themed('colorGradientLeft');
                .refresh-loading-info {
                    color: #fff;
                    font-size: 14px;
                    font-weight: bold;
                }
            }

            .user-center-container {
                position: relative;
                margin-bottom: 30px;
                display: flex;
                flex-direction: column;
                z-index: 100;
                *{
                    font-size:0.4rem;
                }
                .info-container,
                .basic-container,
                .common-container {
                    overflow: hidden;
                }

                .info-name,
                .basic-title,
                .common-title {
                    color: #333333;
                    font-size: 16px;
                    font-weight: bold;
                }

                .title-background-container {
                    position: absolute;
                    z-index: -1;
                    width: 100%;
                    height: 4rem;
                    box-sizing: border-box;
                    background: linear-gradient(180deg, themed('colorGradientLeft') 0%, themed('colorGradientRight') 100%);
                    border-radius: 0px 0px 1rem 1rem;
                }

                .info-container {
                    width: 100%;
                    box-sizing: border-box;
                }

                .info-wrap {
                    display: flex;
                    align-items: center;
                    padding: 1rem 0.5rem 0.1rem 0.5rem;

                    .info-content {
                        display: flex;
						height: 1.2rem;
                        justify-content: center;
						flex-direction: column;
                        margin-left: 15px;
                        flex: 1;
                        
                        .info-name {
							display: inline;
                            color: #fff;
                            font-size: 20px;
                            font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
                        }

						.info-tag {
							display: inline;
						}

						.van-tag--plain {
							font-size: 11px;
							font-weight: lighter;
							color: themed('colorTag');
						}

						.info-id {
                            color: #fff;
                            font-size: 12px;
							font-weight: 400;
							margin: 5px 0;
						}
                        .icon {
                            font-size: 20px;
                            margin-left: 5px;
                        }
                    }
                }

                .info-value-title {
                    margin-bottom: 0.5rem;
                    font-size: 0.35rem;
                    color: #999;
                }
                
                .info-value {
                    color: #333;
                    font-weight: 550;
                    font-size: 0.45rem;
					line-height: 0.6rem;
                }

                .basic-title,
                .common-title {
                    padding: 10px;
                    border-bottom: 1px solid #ebedf0;
                }

                .icon {
                    font-size: 22px;
                }

                .icon-basic,
                .icon-common {
                    position: relative;
                    /*filter: drop-shadow(10px 10px 0 #c8c9cc);*/
                    .icon{
                        padding-bottom: 10px;
                    }
                }

                .basic-text,
                .common-text {
                    margin-top: 5px;
                }

                /deep/ .van-cell-group {
                    display: flex;
                    flex: 1;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    background: inherit;

                    .van-cell {
                        width: 90%;
                    }

                    >.van-cell:nth-child(1) {
                        border-radius: 0.3rem 0.3rem 0 0;
                    }

                    >.van-cell:last-child {
                        border-radius:0 0 0.3rem 0.3rem;
                    }
                }
            }

            .theme-title {
                display: flex;
                justify-content: center;
                height: 10vh;
                line-height: 10vh;
                color: #999;
                font-size: 16px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/user/Index.vue